
import React from "react";
import { useTranslation } from "react-i18next";
import { MapPin, Phone, Mail } from "lucide-react";

const navLinks = [
  { href: "#home", key: "navigation.home" },
  { href: "#about", key: "navigation.about" },
  { href: "#marine", key: "navigation.marine" },
  { href: "#containers", key: "navigation.containers" },
  { href: "#scan", key: "navigation.scan" },
  { href: "#projects", key: "navigation.projects" },
  { href: "#contact", key: "navigation.contact" },
];

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();


  return (
    <footer className="bg-[#070e1a] border-t border-white/10" aria-label="Stopka strony">
      <div className="container mx-auto px-4 pt-12 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">

          {/* Kolumna 1: Firma 1 */}
          <div>
            <p className="text-slate-100 font-bold text-lg mb-1">REMAR Engineering</p>
            <p className="text-slate-400 text-sm mb-4 max-w-[220px] leading-relaxed">{t("footer.tagline_engineering")}</p>
            <address className="not-italic text-slate-400 text-sm space-y-2">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-blue-400" aria-hidden="true" />
                <span>
                  ul. Gdańska 36<br />
                  70-660 Szczecin, Polska
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 shrink-0 text-blue-400" aria-hidden="true" />
                <a href="tel:+48691504287" className="hover:text-blue-400 transition-colors">
                  +48 691 504 287
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 shrink-0 text-blue-400" aria-hidden="true" />
                <a href="mailto:biuro@remar.repair" className="hover:text-blue-400 transition-colors">
                  biuro@remar.repair
                </a>
              </div>
            </address>
          </div>

          {/* Kolumna 2: Firma 2 */}
          <div>
            <p className="text-slate-100 font-bold text-lg mb-1">REMAR Repairs & Outfitting</p>
            <p className="text-slate-400 text-sm mb-4 max-w-[220px] leading-relaxed">{t("footer.tagline")}</p>
            <address className="not-italic text-slate-400 text-sm space-y-2">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-blue-400" aria-hidden="true" />
                <span>
                  ul. Gdańska 36<br />
                  70-660 Szczecin, Polska
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 shrink-0 text-blue-400" aria-hidden="true" />
                <a href="tel:+48601707453" className="hover:text-blue-400 transition-colors">
                  +48 601 707 453
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 shrink-0 text-blue-400" aria-hidden="true" />
                <a href="mailto:biuro@remar.repair" className="hover:text-blue-400 transition-colors">
                  biuro@remar.repair
                </a>
              </div>
            </address>
          </div>

          {/* Kolumna 2: Usługi */}
          <nav aria-label={t("footer.services_label")}>
            <p className="text-slate-100 font-semibold text-sm uppercase tracking-wider mb-4">
              {t("footer.services_label")}
            </p>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li><a href="#marine" className="hover:text-blue-400 transition-colors">{t("footer.services.marine")}</a></li>
              <li><a href="#marine" className="hover:text-blue-400 transition-colors">{t("footer.services.welding")}</a></li>
              <li><a href="#containers" className="hover:text-blue-400 transition-colors">{t("footer.services.containers")}</a></li>
              <li><a href="#scan" className="hover:text-blue-400 transition-colors">{t("footer.services.scanning")}</a></li>
              <li><a href="#scan" className="hover:text-blue-400 transition-colors">{t("footer.services.reverse")}</a></li>
            </ul>
          </nav>

          {/* Kolumna 3: Nawigacja */}
          <nav aria-label={t("footer.nav_label")}>
            <p className="text-slate-100 font-semibold text-sm uppercase tracking-wider mb-4">
              {t("footer.nav_label")}
            </p>
            <ul className="space-y-2 text-slate-400 text-sm">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="hover:text-blue-400 transition-colors">
                    {t(link.key)}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-2 text-slate-400 text-sm">
          <p>© {currentYear} REMAR Engineering. {t("footer.rights")}</p>
          <p className="text-xs text-slate-500">remar.repair</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
